import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e5680f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative tw-flex-1 tw-z-1 tw-pb-[10px] md:tw-pb-0" }
const _hoisted_2 = { class: "tw-flex tw-w-[449px]" }
const _hoisted_3 = { class: "tw-flex tw-justify-around tw-items-center tw-w-full" }
const _hoisted_4 = { class: "hover-modal" }
const _hoisted_5 = { class: "tw-w-full tw-bg-[#ffffff] tw-h-full tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1]" }

import SearchIcon from "@/components/svgs/searchIcon.vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import { Ref, ref, onMounted, onUnmounted, computed, watch } from "vue";
import BaseForm from "../common/form/baseForm.vue";
import InputField from "../common/inputField1.vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import ModalSearchAssessment from "@/components/assessment/modalSearchAssessment.vue";
import ModalHoverSearchAssessment from "@/components/assessment/modalHoverSearchAssessment.vue";
import SearchFilter from "./searchFilter.vue";
import store from "@/store";
import { IAssessmentChecklistItem } from "@/interfaces/assessments/IAssessmentDetails";
import {
  assessmentQuestionVisibleState,
  localStorageKey,
  mainSearchAssessmentFilterDefaul,
  SEARCH_TYPE_ID,
} from "@/utils/constants";
import AssessmentQuestionsTable from "@/components/assessment/assessmentQuestionsTable.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IFilterSelect } from "@/interfaces/common/common";
import { groupFilters } from "@/services/vendor";
import { useRoute } from "vue-router";
import { isValidCompliance, isValidScoreIncrease } from "@/services/assessment";


export default /*#__PURE__*/_defineComponent({
  __name: 'searchBox',
  props: {
  searchListQuestion: {
    type: Array,
    required: true,
    default: () => [],
  },
  initalValueSearch: {
    type: String,
    required: true,
  },
  hintText: {
    type: String,
    required: true,
  },
  activeCategory: {
    type: [Object, Number, String],
    required: true,
  },
},
  emits: [
  "update:modelValue",
  "currentValueSearch",
  "open-evidence-modal",
  "close-evidence-modal",
  "excludeItem",
  "open-wide-search",
  "update-checklist-all",
],
  setup(__props, { emit }) {

const props = __props;

const route = useRoute();

// eslint-disable-next-line no-unused-vars


const modelValue: Ref<string> = ref("");
const isShowFilterAction: Ref<boolean> = ref(false);
const lastCallApiValueSearch = ref("");
const isLoadingAssessmentItem = ref(store.state.Assessment.loadingSearch);
const onInputModalFocus = ref(false);
const filteredModelValue: Ref<string> = ref("");
const showModalAssessment: Ref<boolean> = ref(false);
const showAdvancedSlideModal: Ref<boolean> = ref(false);

const isAutoFocus: Ref<boolean> = ref(false);
let valueSearch = "";
const seletedAssessmentRow: Ref<any[]> = ref([]);

const handleSelectAssessment = (selectedRows: number[]) => {
  seletedAssessmentRow.value = selectedRows;
};

watch(
  () => store.state.Assessment.loadingSearch,
  (value) => {
    isLoadingAssessmentItem.value = value;
  },
);

const originSelected: Ref<IFilterSelect[]> = ref(
  localStorage.getItem(localStorageKey.mainSearchAssessmentFilter) &&
    localStorage.getItem(localStorageKey.mainAssessmentFilterId) ==
      route.query.checklistId
    ? JSON.parse(
        localStorage.getItem(localStorageKey.mainSearchAssessmentFilter) ||
          "{}",
      ) || mainSearchAssessmentFilterDefaul
    : mainSearchAssessmentFilterDefaul,
);

const selectedCategory = computed(() => {
  const category = originSelected.value.find(
    (item) => item.targetId === "checklistItemCategoryId",
  );
  if (category && category.value) {
    return category.value;
  }
  return null;
});

const filterSelected = ref(
  localStorage.getItem(localStorageKey.mainSearchAssessmentFilter) &&
    localStorage.getItem(localStorageKey.mainAssessmentFilterId) ==
      route.query.checklistId
    ? groupFilters(
        JSON.parse(
          localStorage.getItem(localStorageKey.mainSearchAssessmentFilter) ||
            "{}",
        ) || mainSearchAssessmentFilterDefaul,
      )
    : groupFilters(mainSearchAssessmentFilterDefaul),
);

watch(
  () => originSelected.value,
  (value) => {
    if (originSelected.value.length === 0) {
      originSelected.value = mainSearchAssessmentFilterDefaul;
      filterSelected.value = groupFilters(mainSearchAssessmentFilterDefaul);
    }
  },
);

const handleApplyFilter = (data: any) => {
  originSelected.value = data.filterSelecteds;
  localStorage.setItem(
    localStorageKey.mainSearchAssessmentFilter,
    JSON.stringify(data.filterSelecteds),
  );
  localStorage.setItem(
    localStorageKey.mainAssessmentFilterId,
    route.query.checklistId as string,
  );
  filterSelected.value = groupFilters(data.filterSelecteds);
};

const getDataChecklistChildAll = computed(() => {
  const data: IAssessmentChecklistItem[] =
    store.getters["Assessment/getChecklistAllForSearchBox"];
  if (originSelected.value && originSelected.value.length > 0) {
    return getDataFilter(data);
  }
  return data;
});

const getDataFilter = (data) => {
  const dataFilter: any = [];
  data.forEach((item) => {
    if (
      (!item.checklistChildren || item.checklistChildren.length === 0) &&
      Object.entries(filterSelected.value).every(([targetId, value]) => {
        if (targetId === "itemCompleteValue-percentage") {
          return isValidCompliance(item, value);
        }

        if (targetId === "score-increase") {
          return isValidScoreIncrease(item, value);
        }

        return (
          (targetId === "itemCompleteValue" &&
            (value.has(1) ||
              (value.has(0) && item.itemCompleteValue === undefined))) ||
          (targetId === "visibleState" &&
            (value.has(1) ||
              (value.has(0) &&
                item.visibleState !== assessmentQuestionVisibleState.no) ||
              item.isMaster)) ||
          value.has(item[targetId])
        );
      })
    ) {
      dataFilter.push(item);
    } else if (item.checklistChildren) {
      const resultChild = getDataFilter(item.checklistChildren);
      if (resultChild.length > 0) {
        const newItem = { ...item, checklistChildren: resultChild };
        dataFilter.push(newItem);
      }
    }
  });
  return dataFilter;
};

const updateModalSearch = (value: any) => {
  filteredModelValue.value = value;
};

const updateInput = (e: any) => {
  emit("update:modelValue", e.target.value);
};

const currentValueSearch = (value: any) => {
  emit("currentValueSearch", value);
};

const clearData = () => {
  modelValue.value = "";
  emit("currentValueSearch", "");
};

const updateCurrentValueSearch = (value: any) => {
  modelValue.value = value;
  emit("currentValueSearch", value);
};

const showAssessmentModal = () => {
  emit("open-wide-search", true);
  filteredModelValue.value = modelValue.value;
  modelValue.value = props.initalValueSearch;
  showModalAssessment.value = true;
  if (modelValue.value && modelValue.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const showSearchAssessmentModal = () => {
  filteredModelValue.value = modelValue.value;
  showModalAssessment.value = true;
};

// Define your component methods
const closeModalAssessment = () => {
  emit("open-wide-search", false);
  eventEmitter.emit(EmitterEvents.CLOSE_ASSESSMENT_ADVANCED_MENU);

  if (showAdvancedSlideModal.value) {
    showAdvancedSlideModal.value = false;
    return;
  }

  eventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_COLLAPSABLE_MENU, false);
  showModalAssessment.value = false;
};

watch(showModalAssessment, (value) => {
  if (value) {
    eventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_COLLAPSABLE_MENU, value);
  }
});

const isInputFocused = ref(false);

const onInputFocus = (isFocus = true) => {
  valueSearch = modelValue.value;
  isInputFocused.value = isFocus;
};

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

const handleClickOutside = (event: MouseEvent) => {
  const button = document.getElementById("click-search-box");

  if (
    button &&
    !button.contains(event.target as Node) &&
    event.target?.id !== "close-iten"
  ) {
    onblur();
  }

  if (event.target?.id === "close-iten" && isInputFocused.value) {
    focusInput();
  }
};

const onblur = () => {
  setTimeout(() => {
    onInputFocus(false);
  }, 300);

  if (modelValue.value && modelValue.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const postAndGetRecentSearch = async () => {
  if (modelValue.value.trim() === "" || valueSearch === modelValue.value)
    return;
  lastCallApiValueSearch.value = modelValue.value;
  await store.dispatch("Assessment/postRecentSearchInput", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
    searchData: {
      text: props.initalValueSearch,
    },
  });
  await store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
  });
};

onMounted(() => {
  window.addEventListener("click", handleClickOutside);
  eventEmitter.on(EmitterEvents.VALUE_SEARCH, (value: any) => {
    modelValue.value = value;
    filteredModelValue.value = value;
  });
  eventEmitter.on(EmitterEvents.CLOSE_RIGHT_SLIDE_MODAL, () => {
    emit("update-checklist-all");
  });
});

onUnmounted(() => {
  window.removeEventListener("click", () => {});
  eventEmitter.off(EmitterEvents.VALUE_SEARCH);
});

const isHover = ref(false);
const onHover = () => {
  isHover.value = true;
};

const outHover = () => {
  isHover.value = false;
};

const focusInput = () => {
  isAutoFocus.value = true;
  setTimeout(() => {
    isAutoFocus.value = false;
  }, 500);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseForm, {
          id: "click-search-box",
          class: _normalizeClass(["search-box-assessment tw-flex tw-items-center tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-p-[15px]", isInputFocused.value ? 'is-input-focused' : '']),
          onMouseover: onHover,
          onMouseout: outHover
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tw-flex tw-flex-row tw-items-center",
              onClick: focusInput
            }, [
              _createVNode(SearchIcon, {
                size: 15,
                color: "#B7B7B7"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(InputField, {
                value: modelValue.value,
                "onUpdate:value": [
                  _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
                  currentValueSearch
                ],
                type: "input",
                placeholder: __props.hintText,
                "is-hover": isHover.value,
                "active-category-name": __props.activeCategory?.checklistItemCategoryName,
                "is-auto-focus": isAutoFocus.value,
                "is-modal": true,
                "class-style": "tw-ml-[9px] !tw-bg-inherit !tw-shadow-none !tw-border-none !tw-outline-[none] !tw-border-0 !tw-text-[#211F58] !tw-text-sm !tw-not-italic !tw-font-medium !tw-leading-[100%]",
                onUpdate: updateInput,
                "onOn:focusSearch": onInputFocus,
                "onOn:enter": _cache[1] || (_cache[1] = ($event: any) => (isInputFocused.value = false))
              }, null, 8, ["value", "placeholder", "is-hover", "active-category-name", "is-auto-focus"]),
              (modelValue.value !== '')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "close-iten",
                    type: "button",
                    class: "tw-bg-transparent tw-border-none tw-outline-none tw-px-[5px]",
                    onClick: clearData
                  }, [
                    _createVNode(CloseBoxIcon, {
                      size: 15,
                      color: "#DBDBDB"
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createVNode(ModalHoverSearchAssessment, {
          "is-search-modal-assessment": true,
          "search-type-id": _unref(SEARCH_TYPE_ID).CL_INPUT,
          onOpenSearchModal: showSearchAssessmentModal,
          onUpdateCurrentValueSearch: updateCurrentValueSearch
        }, null, 8, ["search-type-id"])
      ], 512), [
        [_vShow, isInputFocused.value]
      ])
    ]),
    _createVNode(ModalComponent, {
      "model-value": showModalAssessment.value,
      close: closeModalAssessment,
      "max-width": 74,
      "class-name": `modal-search-assessment`
    }, {
      default: _withCtx(() => [
        _createVNode(ModalSearchAssessment, {
          "seleted-assessment-row": seletedAssessmentRow.value,
          "origin-selected": originSelected.value,
          "filter-selected": filterSelected.value,
          "on-input-modal-focus": onInputModalFocus.value,
          "onUpdate:applyFilter": handleApplyFilter,
          onCloseModal: closeModalAssessment,
          "onUpdate:showFilterModal": _cache[6] || (_cache[6] = (value) => (isShowFilterAction.value = value)),
          "onUpdate:loading": _cache[7] || (_cache[7] = (value) => (isLoadingAssessmentItem.value = value))
        }, {
          searchFilter: _withCtx(() => [
            _createVNode(SearchFilter, {
              modelValue: filteredModelValue.value,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((filteredModelValue).value = $event)),
                _cache[3] || (_cache[3] = (value) => updateModalSearch(value))
              ],
              "hint-text": 
            _unref(getComponentUiText)('app-prospect-questions-search-text-1')
          ,
              "is-show-filter-action": isShowFilterAction.value,
              "selected-category": selectedCategory.value,
              "onUpdate:searchFocus": _cache[4] || (_cache[4] = 
            (val) => {
              onInputModalFocus.value = val;
            }
          )
            }, null, 8, ["modelValue", "hint-text", "is-show-filter-action", "selected-category"])
          ]),
          listFilter: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(AssessmentQuestionsTable, {
                loading: isLoadingAssessmentItem.value,
                "is-hide-exclude-item": false,
                "table-data": getDataChecklistChildAll.value,
                "search-key": filteredModelValue.value,
                column: [
              'orderNumber',
              'checklistItemImportanceId',
              'itemCompleteValue',
              'totalScore',
            ],
                "onOn:openAdvancedSlideModal": _cache[5] || (_cache[5] = ($event: any) => (showAdvancedSlideModal.value = $event)),
                onUpdateSelectedRows: handleSelectAssessment
              }, null, 8, ["loading", "table-data", "search-key"])
            ], 512), [
              [_vShow, showModalAssessment.value]
            ])
          ]),
          _: 1
        }, 8, ["seleted-assessment-row", "origin-selected", "filter-selected", "on-input-modal-focus"])
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}
}

})